/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/12/22, 9:13 AM
 *
 */

import { useQuery } from 'react-query';

import { getMemberSubscriptionDetails } from 'features/members/api/requests/member.request';

export const useMemberSubsDetails = (memberId: number) => {
  return useQuery(['member-subs-details', memberId], () => getMemberSubscriptionDetails(memberId), {
    enabled: !!memberId,
  });
};
